<template>
  <div>
    <md-field>
      <label>角色元件</label>
      <md-select v-model="form._id" name="_id">
        <md-option :value="item._id" v-for="item in list" :key="item._id">{{ item.name }}</md-option>
      </md-select>
    </md-field>
    <md-field>
      <label>动作列表</label>
      <md-select v-model="form.templateId" name="actionList">
        <md-option :value="item.id" v-for="item in actionMap[form._id]" :key="item.id">{{ item.name }}</md-option>
      </md-select>
    </md-field>
    <md-field v-if="template === 'talk'">
      <label>说话内容</label>
      <md-input v-model="form.talkContent" type="text"></md-input>
    </md-field>
    <md-field v-if="template === 'talk'">
      <label>显示时间</label>
      <md-input v-model="form.showTime" type="number"></md-input>
    </md-field>
    <md-field v-if="template === 'tag'">
      <label>内容</label>
      <md-input v-model="form.tipContent" type="text"></md-input>
    </md-field>
    <md-field v-if="template === 'tag'">
      <label>时长</label>
      <md-input v-model="form.tipShowTime" type="text"></md-input>
    </md-field>
    <div class="md-layout" v-if="template === 'tag'">
      <div class="md-layout-item md-size-10">
          <label>位置</label>
      </div>
      <div class="md-layout-item md-size-30">
        <md-field v-if="template === 'tag'">
          <label>x</label>
          <md-input v-model="form.tipPositionX" type="text"></md-input>
        </md-field>
      </div>
      <div class="md-layout-item md-size-30">
        <md-field v-if="template === 'tag'">
          <label>y</label>
          <md-input v-model="form.tipPositionY" type="text"></md-input>
        </md-field>
      </div>
      <div class="md-layout-item md-size-30">
        <md-field v-if="template === 'tag'">
          <label>z</label>
          <md-input v-model="form.tipPositionZ" type="text"></md-input>
        </md-field>
      </div>
    </div>
  </div>
</template>

<script>
import { listRoleComponent } from '@/api/component/role_component'
import { copyProperty } from '@/utils/util'
import { innerAction } from '../../RoleAction'
export default {
  data() {
    return {
      form: {},
      pagination: {
        perPage: 1000,
        currentPage: 1
      },
      actionMap: {},
      list: [],
      disabled: false
    }
  },
  computed: {
    template() {
      const temp_id = this.form.templateId
      if (temp_id && this.actionMap[this.form._id]) {
        const act = this.actionMap[this.form._id].find((item) => item.id === temp_id)
        this.form.talkContent = this.form.talkContent ?? act.talkContent
        const meta = this.list.find(item => item._id === this.form._id)
        this.form.roleName = meta ? meta.name : ''
        copyProperty(['zbx', 'zby', 'zbz', 'sjx', 'sjy', 'sjz', 'move_mod', 'role_view', 'lockview'], this.form, act)
        this.disabled = act.type === 'static'
        this.form.actionData = act
        return act.template
      }
      return ''
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    init(form) {
      this.form = form ?? {}
    },
    async getList() {
      const result = await listRoleComponent(this.pagination)
      if (result.code == 200) {
        this.list = result.data.rows

        this.actionMap = result.data.rows.reduce((pre, next) => {
          pre[next._id] = next.action_list.concat(innerAction.flatMap(item => item.action_list))
          return pre
        }, {})
      }
    }
  }
}
</script>

<style>

</style>
